import { useState, useRef, useEffect } from 'react';

/**
 * Org name chip with optional multi-org dropdown (v3 topbar).
 */
export default function OrgSwitcher({ orgs = [], currentOrgId, currentOrgName, onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const multi = orgs.length > 1;

  useEffect(() => {
    if (!open) return;
    function onDoc(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  return (
    <div
      ref={ref}
      className={`org-switch${open ? ' open' : ''}`}
      onClick={() => multi && setOpen((o) => !o)}
      onKeyDown={(e) => e.key === 'Enter' && multi && setOpen((o) => !o)}
      role={multi ? 'button' : undefined}
      tabIndex={multi ? 0 : undefined}
    >
      <span className="org-dot" />
      {currentOrgName || 'Organisation'}
      {multi && <span className="org-arr">▾</span>}
      {open && multi && (
        <div className="org-dd" onClick={(e) => e.stopPropagation()}>
          {orgs.map((o) => (
            <button
              key={o.id}
              type="button"
              className={`org-dd-item${o.id === currentOrgId ? ' on' : ''}`}
              onClick={() => { onSelect?.(o); setOpen(false); }}
            >
              <span className="org-dot" style={{ background: o.id === currentOrgId ? '#534AB7' : '#1D9E75' }} />
              {o.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
